import { createFileRoute } from "@tanstack/react-router";
import { IssueDetail } from "@/components/assets/issues/issue-detail";
import { assetIssueNotificationsQuery, assetIssueQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/assets/issues/$id")({
  // A head start; the page renders its own skeleton.
  loader: ({ context, params }) => {
    warm(context.queryClient.ensureQueryData(assetIssueQuery(params.id)));
    warm(context.queryClient.ensureQueryData(assetIssueNotificationsQuery));
  },
  component: AssetIssuePage,
});

function AssetIssuePage() {
  const { id } = Route.useParams();
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-5xl">
        <IssueDetail issueId={id} />
      </div>
    </main>
  );
}
